import { createSlice } from '@reduxjs/toolkit'

// Creating a user slice
const userSlice = createSlice({
  name: 'users',
  initialState: {
    usersList: [],
    loggedIn: false,
    ipCountry: null,
    queryParameter: {}
  },
  reducers: {
    addUser: (state, action) => {
      state.loggedIn = action.payload
    },
    setIpCountry: (state, action) => {
      state.ipCountry = action.payload
    },
    setQueryParameter: (state, action) => {
      state.queryParameter = action.payload
    }
  }
})

//// * * * Creating a user actions * * *
export const { addUser, setIpCountry, setQueryParameter } = userSlice.actions

export default userSlice.reducer


